import React from 'react';
import PropTypes from 'prop-types';

export const TABS = {
  library: 1,
  myTemplate: 2,
};

const ListTemplate = ({ items, onItemClick }) => (
  <div className="list-template">
    {items.map((item, index) => (
      <div
        onClick={() => onItemClick(index)}
        className="template-item"
        key={index}
      >
        <div className="template-image">
          <img alt={item.name} src={item.thumbnails} />
        </div>
        <div className="template-name">{item.name}</div>
      </div>
    ))}
  </div>
);

ListTemplate.propTypes = {
  items: PropTypes.array,
  onItemClick: PropTypes.func,
};

ListTemplate.defaultProps = {
  items: [],
  onItemClick: () => {},
};

export default ListTemplate;
